import { null as zNull } from "zod";

export const disconnectCloudXIntegration = {
  name: "disconnectCloudXIntegration" as const,
  input: zNull(),
  output: zNull(),
};
